import React, { Component } from 'react';
import { connect } from "react-redux";
import HistoryIcon from '../../../assets/images/history.svg';
import SaveIcon from '../../../prat_screen/gt/images/draft.svg';
import CustomSelect from "../../../components/common/select/Select";
import ProductMiddleware from "../../../store/prat_middleware/gt/productMiddleware";
import GeoMiddleware from '../../../store/prat_middleware/gt/geoMiddleware';
import ChannelMiddleware from "../../../store/prat_middleware/gt/channelMiddleware";
import ConsumerPromotionMiddleware from '../../../store/middleware/consumerPromotionMiddleware';
import DurationMiddleware from "../../../store/prat_middleware/gt/durationMiddleware";
import { compare } from '../../../prat_screen/gt/validation/sort';
import { Loader } from "../../../components/loader";
import CustomToast from '../../../util-functions/customToast.jsx';
import DATA from '../../../assets/data';
import ConsumerPromotionHistory from '../consumer-promotion-history/ConsumerPromotionHistory';
import './ConsumerPromotionForm.styles.scss';

class ConsumerPromotionForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedCategory: null,
            selectedBrand: null,
            selectedMasterSku: null,
            selectedSecondaryMasterSku: null,
            selectedConsumerPromotionType: null,
            selectedGeoRegions: [],
            selectedMasterChannels: [],
            selectedChannels: [],
            selectedStartWeek: null,
            selectedEndWeek: null,
            myChannels: [],
            myBrands: [],
            myMasterSkus: [],
            consumerPromotionCode: '',
            consumerPromotionName: '',
            incentive: 0.00,
            volumeCap: 0.00,
            activityCode: '',
            projectCode: '',
            initialLoading: true,
            isDraft: false,
            isActive: false,
            isFinalized: false,
            isDraftSaved: true,
            getData: true,
            startWeekFilterPoint: null,
            isOpen: false,
            currentJCWeekLstSelectedStartWeek: true,
            updateCP: false,
            submitCP: false,
            deactiveCP: false,
            years: [],
            selectedYear: new Date().getFullYear(),
            isExecuted: false,
            mskuGrammage: 0,
            mskuVolCap: 0,
            secMskuGrammage: 0,
            secMskuVolCap: 0,
            selectedSecBrand: null,
            selectedSecCategory: null,
            mySecBrands: [],
            mySecMsku: [],
            yearTo: null
        }
    }

    componentDidMount() {
        let cpId = this.props.location.search.substr(4,);
        let currentYear = new Date().getFullYear();
        let nextYear = new Date().getFullYear() + 1;
        let years = [{ value: currentYear, label: currentYear }, { value: nextYear, label: nextYear }];

        this.setState({
            years,
            yearTo: currentYear
        })

        this.props.getConsumerPromotionById(cpId);
        this.props.productCategories();
        this.props.productBrands();
        this.props.productMasterSkus();
        this.props.geoRegions();
        this.props.masterChannel();
        this.props.channel();
        this.props.consumerPromotionTypes();
    };

    handleConsumerPromotionType = value => {
        if (value) {
            this.setState({ selectedConsumerPromotionType: value.value }, () => {
                this.checkSingleValueForDraftCheck(this.state.selectedConsumerPromotionType, this.props.consumerPromotionById.MetaData.CpType);
            });
        }
    };

    handleCategory = value => {
        if (value && (value.value !== this.state.selectedCategory)) {
            this.setState({ selectedCategory: value.value, selectedBrand: null, selectedMasterSku: null }, () => {
                this.handleFilteredBrands('cat');
                this.checkSingleValueForDraftCheck(this.state.selectedCategory, this.props.consumerPromotionById.MetaData.Category);
            });
        }
    };

    handleSecCategory = value => {
        if (value && (value.value !== this.state.selectedSecCategory)) {
            this.setState({ selectedSecCategory: value.value, selectedSecBrand: null, selectedSecondaryMasterSku: null }, () => {
                this.handleFilteredBrands('secCat');
                // this.checkSingleValueForDraftCheck(this.state.selectedSecCategory, this.props.consumerPromotionById.MetaData.Category);
            });
        }
    };

    handleFilteredBrands = (catType) => {
        const {
            selectedSecCategory,
            selectedCategory
        } = this.state;
        const { productBrandsArray } = this.props;
        let filteredbrands = [];
        if (catType === 'cat') {
            if (selectedCategory) {
                filteredbrands.push(
                    ...productBrandsArray.filter(item => {
                        return item.Category === selectedCategory;
                    })
                );
                this.setState({
                    myBrands: filteredbrands
                }, () =>
                    this.handleFilteredMasterSku('brands')
                );
            }
        }
        else {
            if (selectedSecCategory) {
                filteredbrands.push(
                    ...productBrandsArray.filter(item => {
                        return item.Category === selectedSecCategory;
                    })
                );
                this.setState({
                    mySecBrands: filteredbrands
                }, () =>
                    this.handleFilteredMasterSku('secBrands')
                );
            }
        }
    };

    handleBrandChange = value => {
        if (value && (value.value !== this.state.selectedBrand)) {
            this.setState({ selectedBrand: value.value, selectedMasterSku: null }, () => {
                this.handleFilteredMasterSku('brands');
                this.checkSingleValueForDraftCheck(this.state.selectedBrand, this.props.consumerPromotionById.MetaData.Brand);
            });
        }
    };

    handleSecBrandChange = value => {
        if (value && (value.value !== this.state.selectedSecBrand)) {
            this.setState({ selectedSecBrand: value.value, selectedSecondaryMasterSku: null }, () => {
                this.handleFilteredMasterSku('secBrands');
                // this.checkSingleValueForDraftCheck(this.state.selectedSecBrand, this.props.consumerPromotionById.MetaData.Brand);
            });
        }
    };

    handleFilteredMasterSku = (brandsType) => {
        const {
            selectedBrand,
            selectedSecBrand
        } = this.state;
        const { productMasterSkusArray } = this.props;
        let filteredSkus = [];
        if (brandsType === 'brands') {
            if (selectedBrand) {
                filteredSkus.push(
                    ...productMasterSkusArray.filter(item => {
                        return item.Brand === selectedBrand;
                    })
                );
                this.setState({
                    myMasterSkus: filteredSkus
                });
            }
        }
        else {
            if (selectedSecBrand) {
                filteredSkus.push(
                    ...productMasterSkusArray.filter(item => {
                        return item.Brand === selectedSecBrand;
                    })
                );
                this.setState({
                    mySecMsku: filteredSkus
                });
            }
        }
    };

    handleMasterSkusChange = value => {
        if (value && (value.value !== this.state.selectedMasterSku)) {
            this.setState({ selectedMasterSku: value.value }, () => {
                this.checkSingleValueForDraftCheck(this.state.selectedMasterSku, this.props.consumerPromotionById.MetaData.MasterSku);
            });
        }
    };

    handleSecondaryMasterSkusChange = value => {
        if (value && (value.value !== this.state.selectedSecondaryMasterSku)) {
            this.setState({ selectedSecondaryMasterSku: value.value }, () => {
                this.checkSingleValueForDraftCheck(this.state.selectedSecondaryMasterSku, this.props.consumerPromotionById.MetaData.SecondaryMasterSku);
            });
        }
    };

    handleInputChange = (e) => {
        let nam = e.target.name;
        let val = e.target.value;
        this.setState({
            [nam]: val,
        });
    };

    handleCPNameChange = (e) => {
        this.setState({
            consumerPromotionName: e.target.value
        }, () => {
            this.checkSingleValueForDraftCheck(this.state.consumerPromotionName, this.props.consumerPromotionById.MetaData.CpName);
        })
    };

    handleIncentiveChange = (e) => {
        this.setState({
            incentive: e.target.value
        }, () => {
            this.checkSingleValueForDraftCheck(this.state.incentive, this.props.consumerPromotionById.MetaData.CpName);
        })
    };

    handleVolCapChange = (e) => {
        this.setState({
            volumeCap: e.target.value
        }, () => {
            this.handleMskuVolCapChange();
            this.handleSecMskuVolCapChange();
            this.checkSingleValueForDraftCheck(this.state.volumeCap, this.props.consumerPromotionById.MetaData.CpName);
        })
    };

    handleCPCodeChange = (e) => {
        this.setState({
            consumerPromotionCode: e.target.value
        }, () => {
            this.checkSingleValueForDraftCheck(this.state.consumerPromotionCode, this.props.consumerPromotionById.MetaData.CpName);
        })
    };

    handleGeoRegionChange = geoRegion => {
        if (geoRegion == null || geoRegion.length === 0) {
            this.setState({
                selectedGeoRegions: []
            },
                () => {
                    this.checkArrayValueForDraftCheck(this.state.selectedGeoRegions, this.props.consumerPromotionById.GeoHierarchy.regions);
                })
        }
        if (geoRegion) {
            let arr = [];
            geoRegion.forEach(e => {
                arr.push(e.value);
            });

            this.setState({ selectedGeoRegions: arr },
                () => {
                    this.checkArrayValueForDraftCheck(this.state.selectedGeoRegions, this.props.consumerPromotionById.GeoHierarchy.regions);
                });
        }
    };

    handleMasterChannelChange = (selectedMasterChannel) => {

        if (selectedMasterChannel == null || selectedMasterChannel.length === 0) {
            this.setState({ selectedMasterChannels: [], myChannels: [], selectedChannels: [] },
                () => {
                    this.checkArrayValueForDraftCheck(this.state.selectedMasterChannels, this.props.consumerPromotionById.ChannelHierarchy.master_channels);
                })
        }
        if (selectedMasterChannel) {
            let arr = [];
            selectedMasterChannel.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedMasterChannels: arr }, () => {
                this.handleFilteredChannel();
                this.checkArrayValueForDraftCheck(this.state.selectedMasterChannels, this.props.consumerPromotionById.ChannelHierarchy.master_channels);
            })
        }
    };

    handleFilteredChannel() {
        const {
            selectedMasterChannels,
            selectedChannels
        } = this.state;
        const { channelArray } = this.props;
        let filteredChannel = [];
        if (selectedMasterChannels.length) {
            for (let i = 0; i < selectedMasterChannels.length; i++) {
                filteredChannel.push(
                    ...channelArray.filter(item => {
                        return item.MasterChannel === selectedMasterChannels[i];
                    })
                );
            }

            let arr = [];
            if (selectedChannels.length) {
                filteredChannel.forEach(item => {
                    if (selectedChannels.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedChannels: arr });
            }

            this.setState({
                myChannels: filteredChannel
            });
        }
    };

    handleChannelChange = (selectedChannel) => {

        if (selectedChannel == null || selectedChannel.length === 0) {
            this.setState({ selectedChannels: [] }, () => {
                this.checkArrayValueForDraftCheck(this.state.selectedChannels, this.props.consumerPromotionById.ChannelHierarchy.channels);
            })
        }
        if (selectedChannel) {
            let arr = [];
            selectedChannel.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedChannels: arr },
                () => {
                    this.checkArrayValueForDraftCheck(this.state.selectedChannels, this.props.consumerPromotionById.ChannelHierarchy.channels);
                })
        }
    };

    handleStartWeekChange = (value) => {
        this.setState({
            selectedStartWeek: value.value,
            selectedEndWeek: null
        }, () => {
            this.checkSingleValueForDraftCheck(parseInt(this.state.selectedStartWeek), parseInt(this.props.consumerPromotionById.MetaData.WeekStart));
        })
    };

    handleEndWeekChange = (value) => {
        this.setState({
            selectedEndWeek: value.value,
            yearTo: value.year
        }, () => {
            this.checkSingleValueForDraftCheck(parseInt(this.state.selectedEndWeek), parseInt(this.props.consumerPromotionById.MetaData.WeekEnd));
        })
    };

    extractWeekNumber = weekArray => {
        if (weekArray?.length) {
            let firstWeek = weekArray[0].substr(5, 2);
            this.setState({
                startWeekFilterPoint: firstWeek
            })
        }
    };

    extractDataFromAPIResponse = (apiData) => {
        let metaData = apiData.MetaData;
        let geoData = apiData.GeoHierarchy;
        let channelData = apiData.ChannelHierarchy;

        this.getWeekNumberFromAPI(metaData.Year, metaData.WeekStart, metaData.IsExecuted);

        this.setState({
            activityCode: metaData.ActivityCode ? metaData.ActivityCode : '',
            projectCode: metaData.ProjectCode ? metaData.ProjectCode : '',
            consumerPromotionName: metaData.CpName ? metaData.CpName : '',
            selectedConsumerPromotionType: metaData.CpType,
            selectedCategory: metaData?.Category,
            selectedBrand: metaData?.Brand,
            selectedMasterSku: metaData.MasterSku,
            selectedSecondaryMasterSku: metaData.SecondaryMasterSku,
            selectedGeoRegions: geoData.regions,
            selectedMasterChannels: channelData.master_channels,
            selectedChannels: channelData.channels,
            incentive: parseFloat(metaData.Incentive),
            volumeCap: parseFloat(metaData.VolumeCap),
            selectedStartWeek: metaData.WeekStart,
            selectedEndWeek: metaData.WeekEnd,
            consumerPromotionCode: metaData.CpCode ? metaData.CpCode : '',
            isDraft: metaData.Isdraft,
            isActive: metaData.IsActive,
            isFinalized: metaData.IsFinalized,
            selectedYear: metaData.Year,
            isExecuted: metaData.IsExecuted,
            mskuGrammage: parseFloat(metaData.MskuGrammage),
            mskuVolCap: parseFloat(metaData.MskuVolumeCap),
            secMskuGrammage: parseFloat(metaData.SecondaryMskuGrammage),
            secMskuVolCap: parseFloat(metaData.SecondaryMskuVolumeCap),
            selectedSecCategory: metaData?.SecondaryCategory,
            selectedSecBrand: metaData?.SecondaryBrand,
            yearTo: metaData?.YearTo
        }, () => {
            this.handleFilteredChannel();
            this.handleFilteredBrands('cat');
            this.handleFilteredBrands('secCat');
            this.handleMskuVolCapChange();
            this.handleSecMskuVolCapChange();
        })
    };

    getWeekNumberFromAPI = (year, startWeek, executed) => {
        this.props.getStartWeek(year, executed ? startWeek : null);
    };

    checkSingleValueForDraftCheck = (stateValue, propsValue) => {
        if (stateValue !== propsValue) {
            this.setState({
                isDraftSaved: false
            })
        }
    };

    checkArrayValueForDraftCheck = (stateValue, propsValue) => {
        if (stateValue?.length !== propsValue?.length) {
            this.setState({
                isDraftSaved: false
            })
        }
        else if (stateValue?.length && propsValue?.length) {
            let missCount = 0;
            for (var i = 0; i < stateValue.length; i++) {
                if (!stateValue.includes(propsValue[i])) {
                    missCount++;
                }
            }
            if (missCount) {
                this.setState({
                    isDraftSaved: false
                })
            }
        }
    };

    handleEmptyValidationCheck = () => {
        const { selectedBrand, selectedCategory, selectedMasterSku, activityCode, projectCode,
            consumerPromotionName, incentive, volumeCap, selectedSecondaryMasterSku,
            selectedGeoRegions, selectedMasterChannels, selectedChannels, consumerPromotionCode,
            selectedStartWeek, selectedEndWeek, selectedConsumerPromotionType,
            isDraft, isActive, isFinalized, isExecuted, mskuGrammage, mskuVolCap,
            secMskuGrammage, secMskuVolCap, selectedSecCategory, selectedSecBrand, yearTo } = this.state;
        let cpId = this.props.location.search.substr(4,);
        let isTrue = false;
        let data = {
            guid: cpId,
            Year: new Date().getFullYear(),
            IsActive: isActive,
            Isdraft: isDraft,
            IsFinalized: isFinalized
        };
        if (!consumerPromotionName) {
            isTrue = true;
            CustomToast('error', 'Consumer promotion name is empty!');
        }
        else {
            data.CpName = consumerPromotionName;
        }
        if (!selectedConsumerPromotionType) {
            isTrue = true;
            CustomToast('error', 'Consumer promotion type is empty!');
        }
        else {
            data.CpType_id = selectedConsumerPromotionType;
        }
        if (!selectedCategory) {
            isTrue = true;
            CustomToast('error', 'Category is empty!');
        }
        if (!selectedBrand) {
            isTrue = true;
            CustomToast('error', 'Brand is empty!');
        }
        if (!selectedMasterSku) {
            isTrue = true;
            CustomToast('error', 'Master MSKU is empty!');
        }
        else {
            data.MasterSku_id = selectedMasterSku;
        }
        if (!selectedSecondaryMasterSku && selectedConsumerPromotionType === 'e66c6e88-2929-4db8-b4da-d91e41572012') {
            isTrue = true;
            CustomToast('error', 'Secondary Master MSKU is empty!');
        }
        else {
            if (selectedConsumerPromotionType === 'e66c6e88-2929-4db8-b4da-d91e41572012') {
                data.SecondaryMasterSku_id = selectedSecondaryMasterSku;
                if (!secMskuGrammage) {
                    isTrue = true;
                    CustomToast('error', 'Secondary MSKU Grammage is empty!');
                }
                else {
                    data.SecondaryMskuGrammage = secMskuGrammage;
                }
                if (!secMskuVolCap) {
                    isTrue = true;
                    CustomToast('error', 'Secondary MSKU Volume Cap is empty!');
                }
                else {
                    data.SecondaryMskuVolumeCap = secMskuVolCap;
                }
                if (!selectedSecCategory) {
                    isTrue = true;
                    CustomToast('error', 'Secondary Category is empty!');
                }
                else {
                    data.SecondaryCategory = selectedSecCategory;
                }
                if (!selectedSecBrand) {
                    isTrue = true;
                    CustomToast('error', 'Secondary Brand is empty!');
                }
                else {
                    data.SecondaryBrand = selectedSecBrand;
                }
            }
        }
        if (!selectedGeoRegions.length) {
            isTrue = true;
            CustomToast('error', 'Region is empty!');
        }
        else {
            data.geographic_detail = { regions: selectedGeoRegions };
        }
        if (!selectedMasterChannels.length) {
            isTrue = true;
            CustomToast('error', 'Master Channel is empty!');
        }
        else {
            data.channel_detail = { master_channels: selectedMasterChannels };
        }
        if (!selectedChannels.length) {
            isTrue = true;
            CustomToast('error', 'Channel is empty!');
        }
        else {
            data.channel_detail = { ...data.channel_detail, channels: selectedChannels };
        }
        if (!incentive) {
            isTrue = true;
            CustomToast('error', 'Incentive is empty!');
        }
        else {
            data.Incentive = incentive;
        }
        if (!volumeCap) {
            isTrue = true;
            CustomToast('error', 'Volume Cap is empty!');
        }
        else {
            data.VolumeCap = volumeCap;
        }
        if (!selectedStartWeek) {
            isTrue = true;
            CustomToast('error', 'Week Start is empty!');
        }
        else {
            if ((isActive && isExecuted)) {

            } else {
                data.WeekStart = parseInt(selectedStartWeek);
            }
        }
        if (!selectedEndWeek) {
            isTrue = true;
            CustomToast('error', 'Week End is empty!');
        }
        else {
            data.WeekEnd = parseInt(selectedEndWeek);
            data.YearTo = yearTo
        }
        if (consumerPromotionCode) {
            data.CpCode = consumerPromotionCode
        }
        if (activityCode) {
            data.ActivityCode = activityCode
        }
        if (projectCode) {
            data.ProjectCode = projectCode
        }
        // if (!selectedYear) {
        //     isTrue = true;
        //     CustomToast('error', 'Year is empty!');
        // }
        // else {
        //     data.Year = selectedYear;
        // }
        if (selectedConsumerPromotionType === 'a6079d12-554e-4300-9521-66ed12b31b8c' ||
            selectedConsumerPromotionType === 'e66c6e88-2929-4db8-b4da-d91e41572012') {
            if (!mskuGrammage) {
                isTrue = true;
                CustomToast('error', 'MSKU Grammage is empty!');
            }
            else {
                data.MskuGrammage = mskuGrammage;
            }
            if (!mskuVolCap) {
                isTrue = true;
                CustomToast('error', 'MSKU Volume Cap is empty!');
            }
            else {
                data.MskuVolumeCap = mskuVolCap;
            }
        }

        return isTrue ? null : data;
    };

    handleSaveDraft = () => {
        let validData = this.handleEmptyValidationCheck();
        let cpId = this.props.location.search.substr(4,);
        if (validData) {
            this.setState({
                updateCP: true
            }, () => {
                this.props.updateConsumerPromotion(cpId, validData);
            })
        }
    };

    handleSubmitActivity = () => {
        let validData = this.handleEmptyValidationCheck();
        let cpId = this.props.location.search.substr(4,);
        if (validData) {
            this.setState({
                submitCP: true
            }, () => {
                this.props.submitConsumerPromotion(cpId, validData);
            })
        }
    }

    handleDeactivateActivity = () => {
        let validData = this.handleEmptyValidationCheck();
        let cpId = this.props.location.search.substr(4,);
        if (validData) {
            this.setState({
                deactiveCP: true
            }, () => {
                this.props.deactivateConsumerPromotion(cpId);
            })
        }
    }

    handleCPHistoryFlag = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    };

    // handleYearChange = (value) => {
    //     if (this.state.selectedYear !== value.value) {
    //         this.setState({
    //             selectedYear: value.value
    //         }, () => {
    //             this.getWeekNumberFromAPI(value.value, '', false);
    //             this.checkSingleValueForDraftCheck(parseInt(this.state.selectedYear), parseInt(this.props.consumerPromotionById.MetaData.Year));
    //         })
    //     }
    // };

    handleMskuGrammageChange = (e) => {
        this.setState({
            mskuGrammage: e.target.value
        }, () => {
            this.handleMskuVolCapChange();
            this.handleSecMskuVolCapChange();
            this.checkSingleValueForDraftCheck(parseInt(this.state.mskuGrammage), parseInt(this.props.consumerPromotionById.MetaData.MskuGrammage));
        })
    };

    handleMskuVolCapChange = () => {
        this.setState({
            mskuVolCap: this.handleVolCapCalculation(this.state.mskuGrammage, this.state.mskuGrammage, this.state.secMskuGrammage, this.state.volumeCap)
        })
    };

    handleSecMskuGrammageChange = (e) => {
        this.setState({
            secMskuGrammage: e.target.value
        }, () => {
            this.handleSecMskuVolCapChange();
            this.handleMskuVolCapChange();
            this.checkSingleValueForDraftCheck(parseInt(this.state.secMskuGrammage), parseInt(this.props.consumerPromotionById.MetaData.SecondaryMskuGrammage));
        })
    };

    handleSecMskuVolCapChange = () => {
        this.setState({
            secMskuVolCap: this.handleVolCapCalculation(this.state.secMskuGrammage, this.state.mskuGrammage, this.state.secMskuGrammage, this.state.volumeCap)
        })
    };

    handleVolCapCalculation = (calculateMskuGrammage, mskuGrammage, secMskuGrammage, volumeCap) => {
        if (mskuGrammage && secMskuGrammage && volumeCap && calculateMskuGrammage) {
            let totalGrammage = parseFloat(mskuGrammage) + parseFloat(secMskuGrammage);
            let calculatedVolCap = (parseFloat(calculateMskuGrammage) * parseFloat(volumeCap)) / totalGrammage;
            return parseFloat(calculatedVolCap)?.toFixed(2);
        }
        else if (this.state.selectedConsumerPromotionType === 'a6079d12-554e-4300-9521-66ed12b31b8c') {
            let totalGrammage = parseFloat(mskuGrammage);
            let calculatedVolCap = (parseFloat(calculateMskuGrammage) * parseFloat(volumeCap)) / totalGrammage;
            return parseFloat(calculatedVolCap)?.toFixed(2);
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.productCategoriesArray?.length
            && this.props.productBrandsArray?.length && this.props.productMasterSkusArray?.length
            && this.props.geoRegionsArray?.length && this.props.masterChannelArray?.length
            && this.props.channelArray?.length && this.state.getData) {
            if (this.props.consumerPromotionById && this.state.getData) {
                if (this.props.consumerPromotionById?.MetaData.guid) {
                    this.extractDataFromAPIResponse(this.props.consumerPromotionById);
                    this.setState({
                        initialLoading: false,
                        getData: false
                    })
                }
            }
        }

        if (prevProps.startWeek !== this.props.startWeek) {
            this.extractWeekNumber(this.props.startWeek);
        }

        if (prevProps.updateConsumerPromotionData !== this.props.updateConsumerPromotionData) {
            if (this.props.updateConsumerPromotionData?.guid) {
                CustomToast('success', 'Draft saved!')
                this.setState({
                    isDraftSaved: true,
                    isExecuted: this.props.updateConsumerPromotionData?.IsExecuted
                })
            }
        }

        if (prevProps.submitConsumerPromotionData !== this.props.submitConsumerPromotionData) {
            if (this.props.submitConsumerPromotionData?.guid) {
                CustomToast('success', 'Promotion Submitted!');
                this.props.history.push('/consumerpromotionlist');
            }
        }

        if (prevProps.deactivateConsumerPromotionData !== this.props.deactivateConsumerPromotionData) {
            CustomToast('success', 'Promotion Deactivated Successfully!');
            this.props.history.push('/consumerpromotionlist');
        }

        if (this.props.deactivateConsumerPromotionHasError && this.state.deactiveCP) {
            CustomToast('error', 'Promotion Deactivation Failed!');
            this.setState({
                deactiveCP: false
            });
        }

        if (this.props.submitConsumerPromotionHasError && this.state.submitCP) {
            CustomToast('error', 'Promotion Activation Failed!');
            this.setState({
                submitCP: false
            });
        }

        if (this.props.updateConsumerPromotionHasError && this.state.updateCP) {
            CustomToast('error', 'Save Draft Failed!');
            this.setState({
                updateCP: false
            });
        }
    };

    render() {
        const { myBrands, selectedBrand, selectedCategory, myMasterSkus, selectedMasterSku,
            consumerPromotionCode, consumerPromotionName, incentive, volumeCap, activityCode, projectCode,
            selectedSecondaryMasterSku, selectedGeoRegions, selectedMasterChannels, selectedChannels,
            myChannels, selectedStartWeek, selectedEndWeek, selectedConsumerPromotionType,
            isDraft, isActive, isFinalized, isDraftSaved, startWeekFilterPoint, isOpen,
            selectedYear, isExecuted, mskuGrammage, mskuVolCap, secMskuGrammage,
            secMskuVolCap, selectedSecBrand, selectedSecCategory, mySecBrands, mySecMsku, yearTo } = this.state;

        const { productCategoriesArray, productBrandsArray, productMasterSkusArray, geoRegionsArray,
            masterChannelArray, channelArray, startWeek, consumerPromotionTypesArray,
            submitConsumerPromotionIsLoading, isGetConsumerPromotionByIdLoading,
            deactivateConsumerPromotionIsLoading } = this.props;
        return (
            <>
                {
                    (this.state.initialLoading || isGetConsumerPromotionByIdLoading
                        || submitConsumerPromotionIsLoading) ?
                        <Loader flag={true} />
                        :
                        <div className="page-container">
                            <div className='component-heading'>Consumer Promotion</div>

                            <div className='cp-form-container'>

                                <div className='df justifyContent-sb'>
                                    <div className='df'>
                                        <span className='cp-form-heading'>Consumer Promotion Detail</span>
                                        {isDraft ? <span className='cp-form-status draft-status'>DRAFT</span> : null}
                                        {isActive ? <span className='cp-form-status active-status'>ACTIVE</span> : null}
                                        {isFinalized ? <span className='cp-form-status'>FINALIZED</span> : null}
                                        {(!isActive && !isDraft) ? <span className='cp-form-status deactive-status'>DEACTIVE</span> : null}
                                    </div>

                                    <div className='df cp-top-left-ctas justifyContent-fe'>
                                        <div className='df alignItem-center cta-cursor' style={{ marginRight: '32px' }} onClick={this.handleCPHistoryFlag}>
                                            <img className='cta-icon' src={HistoryIcon} alt="" />
                                            <span className='cta-label'><u>See History</u></span>
                                        </div>

                                        <div className='df alignItem-center cta-cursor' onClick={this.handleSaveDraft}>
                                            <img className='cta-icon' src={SaveIcon} alt="" />
                                            {isDraftSaved ?
                                                <span className='cta-label'><u>Saved</u></span>
                                                :
                                                <span className='cta-label'><u>Save Draft</u></span>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className='cp-filter-group'>
                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label'>Activity Code</label>
                                        <input
                                            className='cp-input mr-16'
                                            disabled
                                            placeholder='Activity Code'
                                            name='activityCode'
                                            value={activityCode}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>

                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label'>Project Code</label>
                                        <input
                                            type='text'
                                            className='cp-input mr-16'
                                            disabled
                                            placeholder='Project Code'
                                            name='projectCode'
                                            value={projectCode}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>

                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label'>CP Name<span className='required-mark'>*</span></label>
                                        <input
                                            type='text'
                                            className='cp-input mr-16'
                                            disabled={!isDraft}
                                            placeholder='Enter CP Name'
                                            name='consumerPromotionName'
                                            value={consumerPromotionName}
                                            onChange={this.handleCPNameChange}
                                        />
                                    </div>

                                    <div className='df fdi-col mb-32 mr-16'>
                                        <label className='cp-filter-label'
                                            title='
                                        Grammage fill-in – free grammage added as a % of the original grammage,
                                        Gifts Cp – value of gift as a % of the SKU price,
                                        Combination CP - discount on bundle offer as a % of the sum of component product prices'
                                        >
                                            Consumer Promotion Type<span className='required-mark'>*</span></label>
                                        <div className='f-s-13'>
                                            <CustomSelect.MyCustomSelect
                                                placeholder={"Consumer Promotion Type"}
                                                allowSelectAll={false}
                                                isDisabled={(consumerPromotionTypesArray?.length && isDraft) ? false : true}
                                                isMulti={false}
                                                options={
                                                    consumerPromotionTypesArray
                                                        ? consumerPromotionTypesArray.map(item => ({
                                                            value: item.guid,
                                                            label: item.Label
                                                        }))
                                                        : []}
                                                onChange={this.handleConsumerPromotionType}
                                                value={
                                                    consumerPromotionTypesArray && selectedConsumerPromotionType
                                                        ? consumerPromotionTypesArray
                                                            .filter(item => {
                                                                return selectedConsumerPromotionType === item.guid;
                                                            })
                                                            .map(item => {
                                                                return {
                                                                    value: item.guid,
                                                                    label: item.Label
                                                                };
                                                            }) : []}
                                            />
                                        </div>
                                    </div>

                                    <div className='df fdi-col mb-32 mr-16'>
                                        <label className='cp-filter-label'>Category<span className='required-mark'>*</span></label>
                                        <div className='f-s-13'>
                                            <CustomSelect.MyCustomSelect
                                                placeholder={"Category"}
                                                allowSelectAll={false}
                                                isDisabled={(productCategoriesArray?.length && isDraft) ? false : true}
                                                isMulti={false}
                                                options={
                                                    productCategoriesArray
                                                        ? productCategoriesArray?.sort(compare).map(item => ({
                                                            value: item.guid,
                                                            label: item.Name
                                                        }))
                                                        : []
                                                }
                                                onChange={this.handleCategory}
                                                value={
                                                    productCategoriesArray && selectedCategory
                                                        ? productCategoriesArray
                                                            .filter(item => {
                                                                return selectedCategory === item.guid;
                                                            })
                                                            .map(item => {
                                                                return {
                                                                    value: item.guid,
                                                                    label: item.Name
                                                                };
                                                            }) : []
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className='df fdi-col mb-32 mr-16'>
                                        <label className='cp-filter-label'>Brand<span className='required-mark'>*</span></label>
                                        <div className='f-s-13'>
                                            <CustomSelect.MyCustomSelect
                                                placeholder={"Brand"}
                                                allowSelectAll={false}
                                                isDisabled={(productBrandsArray?.length && isDraft) ? false : true}
                                                isMulti={false}
                                                options={
                                                    myBrands.length !== 0
                                                        ? myBrands.sort(compare).map(item => ({
                                                            value: item.guid,
                                                            label: item.Name
                                                        }))
                                                        : []
                                                }
                                                onChange={this.handleBrandChange}
                                                value={
                                                    myBrands && selectedBrand
                                                        ? myBrands
                                                            .filter(item => {
                                                                return selectedBrand === item.guid;
                                                            })
                                                            .map(item => {
                                                                return {
                                                                    value: item.guid,
                                                                    label: item.Name
                                                                };
                                                            }) : []
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className='df mb-32'>
                                        <div className='df fdi-col mr-16 width-100-pre'>
                                            <label className='cp-filter-label'>MSKU<span className='required-mark'>*</span></label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"MSKU"}
                                                    allowSelectAll={false}
                                                    isDisabled={(productMasterSkusArray?.length && isDraft) ? false : true}
                                                    isMulti={false}
                                                    options={
                                                        myMasterSkus
                                                            ? myMasterSkus.sort(compare).map(item => ({
                                                                value: item.guid,
                                                                label: `${item.Description} (${item.Code}) `
                                                            }))
                                                            : []
                                                    }
                                                    onChange={this.handleMasterSkusChange}
                                                    value={
                                                        myMasterSkus && selectedMasterSku
                                                            ? myMasterSkus
                                                                .filter(item => {
                                                                    return selectedMasterSku === item.guid;
                                                                })
                                                                .map(item => {
                                                                    return {
                                                                        value: item.guid,
                                                                        label: `${item.Description} (${item.Code}) `
                                                                    };
                                                                })
                                                            : []
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {
                                            selectedConsumerPromotionType === 'a6079d12-554e-4300-9521-66ed12b31b8c' ||
                                                selectedConsumerPromotionType === 'e66c6e88-2929-4db8-b4da-d91e41572012' ?
                                                <div className='df width-50-pre'>
                                                    <div className='df fdi-col width-50-pre'>
                                                        <label className='cp-filter-label'>Grammage<span className='required-mark'>*</span></label>
                                                        <input
                                                            type='number'
                                                            className='cp-input mr-16 f-s-13'
                                                            disabled={!isDraft}
                                                            placeholder='Enter Incentive %'
                                                            name='incentive'
                                                            value={mskuGrammage}
                                                            style={{ padding: '7px 8px' }}
                                                            onChange={this.handleMskuGrammageChange}
                                                        />
                                                    </div>
                                                    <div className='df fdi-col width-50-pre'>
                                                        <label className='cp-filter-label'>Volume Cap<span className='required-mark'>*</span> (tons)</label>
                                                        <input
                                                            type='number'
                                                            className='cp-input mr-16 f-s-13'
                                                            disabled={true}
                                                            placeholder=''
                                                            name='volumeCap'
                                                            value={mskuVolCap}
                                                            style={{ padding: '7px 8px' }}
                                                            onChange={this.handleMskuVolCapChange}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>


                                    {
                                        selectedConsumerPromotionType === 'e66c6e88-2929-4db8-b4da-d91e41572012'
                                            ?
                                            <>
                                                <div className='df fdi-col mb-32 mr-16'>
                                                    <label className='cp-filter-label'>Secondary Category<span className='required-mark'>*</span></label>
                                                    <div className='f-s-13'>
                                                        <CustomSelect.MyCustomSelect
                                                            placeholder={"Secondary Category"}
                                                            allowSelectAll={false}
                                                            isDisabled={(productCategoriesArray?.length && isDraft) ? false : true}
                                                            isMulti={false}
                                                            options={
                                                                productCategoriesArray
                                                                    ? productCategoriesArray?.sort(compare).map(item => ({
                                                                        value: item.guid,
                                                                        label: item.Name
                                                                    }))
                                                                    : []
                                                            }
                                                            onChange={this.handleSecCategory}
                                                            value={
                                                                productCategoriesArray && selectedSecCategory
                                                                    ? productCategoriesArray
                                                                        .filter(item => {
                                                                            return selectedSecCategory === item.guid;
                                                                        })
                                                                        .map(item => {
                                                                            return {
                                                                                value: item.guid,
                                                                                label: item.Name
                                                                            };
                                                                        }) : []
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className='df fdi-col mb-32 mr-16'>
                                                    <label className='cp-filter-label'>Secondary Brand<span className='required-mark'>*</span></label>
                                                    <div className='f-s-13'>
                                                        <CustomSelect.MyCustomSelect
                                                            placeholder={"Secondary Brand"}
                                                            allowSelectAll={false}
                                                            isDisabled={(productBrandsArray?.length && isDraft) ? false : true}
                                                            isMulti={false}
                                                            options={
                                                                mySecBrands.length !== 0
                                                                    ? mySecBrands.sort(compare).map(item => ({
                                                                        value: item.guid,
                                                                        label: item.Name
                                                                    }))
                                                                    : []
                                                            }
                                                            onChange={this.handleSecBrandChange}
                                                            value={
                                                                mySecBrands && selectedSecBrand
                                                                    ? mySecBrands
                                                                        .filter(item => {
                                                                            return selectedSecBrand === item.guid;
                                                                        })
                                                                        .map(item => {
                                                                            return {
                                                                                value: item.guid,
                                                                                label: item.Name
                                                                            };
                                                                        }) : []
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className='df mb-32'>
                                                    <div className='df fdi-col mr-16 width-100-pre'>
                                                        <label className='cp-filter-label'>Secondary MSKU<span className='required-mark'>*</span></label>
                                                        <div className='f-s-13'>
                                                            <CustomSelect.MyCustomSelect
                                                                placeholder={"Secondary MSKU"}
                                                                allowSelectAll={false}
                                                                isDisabled={(productMasterSkusArray?.length && isDraft) ? false : true}
                                                                isMulti={false}
                                                                options={
                                                                    mySecMsku
                                                                        ? mySecMsku.sort(compare).map(item => ({
                                                                            value: item.guid,
                                                                            label: `${item.Description} (${item.Code}) `
                                                                        }))
                                                                        : []
                                                                }
                                                                onChange={this.handleSecondaryMasterSkusChange}
                                                                value={
                                                                    mySecMsku && selectedSecondaryMasterSku
                                                                        ? mySecMsku
                                                                            .filter(item => {
                                                                                return selectedSecondaryMasterSku === item.guid;
                                                                            })
                                                                            .map(item => {
                                                                                return {
                                                                                    value: item.guid,
                                                                                    label: `${item.Description} (${item.Code}) `
                                                                                };
                                                                            })
                                                                        : []
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='df width-50-pre'>
                                                        <div className='df fdi-col width-50-pre'>
                                                            <label className='cp-filter-label'>Grammage<span className='required-mark'>*</span></label>
                                                            <input
                                                                type='number'
                                                                className='cp-input mr-16 f-s-13'
                                                                disabled={!isDraft}
                                                                placeholder='Enter Incentive %'
                                                                name='incentive'
                                                                value={secMskuGrammage}
                                                                style={{ padding: '7px 8px' }}
                                                                onChange={this.handleSecMskuGrammageChange}
                                                            />
                                                        </div>
                                                        <div className='df fdi-col width-50-pre'>
                                                            <label className='cp-filter-label'>Volume Cap<span className='required-mark'>*</span> (tons)</label>
                                                            <input
                                                                type='number'
                                                                className='cp-input mr-16 f-s-13'
                                                                disabled={true}
                                                                placeholder=''
                                                                name='volumeCap'
                                                                value={secMskuVolCap}
                                                                style={{ padding: '7px 8px' }}
                                                                onChange={this.handleSecMskuVolCapChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            null
                                    }

                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label'>Region<span className='required-mark'>*</span></label>
                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Region"}
                                            allowSelectAll={true}
                                            isDisabled={(geoRegionsArray?.length && isDraft) ? false : true}
                                            isMulti
                                            options={
                                                geoRegionsArray
                                                    ? geoRegionsArray.sort(compare).map(item => ({
                                                        value: item.guid,
                                                        label: item.Name
                                                    }))
                                                    : []
                                            }
                                            onChange={this.handleGeoRegionChange}
                                            value={
                                                geoRegionsArray
                                                    ? geoRegionsArray
                                                        .filter(item => {
                                                            return selectedGeoRegions.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        })
                                                    : []
                                            }
                                        />
                                    </div>

                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label'>Master Channel<span className='required-mark'>*</span></label>
                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Master Channel"}
                                            allowSelectAll={true}
                                            isDisabled={(masterChannelArray?.length && isDraft) ? false : true}
                                            isMulti
                                            options={
                                                masterChannelArray
                                                    ? masterChannelArray.map(item => {
                                                        return {
                                                            value: item.guid,
                                                            label: item.Name
                                                        };
                                                    })
                                                    : []
                                            }
                                            onChange={this.handleMasterChannelChange}
                                            value={
                                                masterChannelArray
                                                    ? masterChannelArray
                                                        .filter(item => {
                                                            return selectedMasterChannels.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        })
                                                    : []
                                            }
                                        />
                                    </div>

                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label'>Channel<span className='required-mark'>*</span></label>
                                        <CustomSelect.MyCustomSelect
                                            placeholder={"Channel"}
                                            allowSelectAll={true}
                                            isDisabled={(channelArray?.length && isDraft) ? false : true}
                                            isMulti
                                            options={
                                                myChannels
                                                    ? myChannels.map(item => {
                                                        return {
                                                            value: item.guid,
                                                            label: item.Name
                                                        };
                                                    })
                                                    : []
                                            }
                                            onChange={this.handleChannelChange}
                                            value={
                                                myChannels
                                                    ? myChannels
                                                        .filter(item => {
                                                            return selectedChannels.includes(item.guid);
                                                        })
                                                        .map(item => {
                                                            return {
                                                                value: item.guid,
                                                                label: item.Name
                                                            };
                                                        })
                                                    : []
                                            }
                                        />
                                    </div>

                                    <div className='df'>
                                        <div className='df fdi-col mb-32 width-50-pre'>
                                            <label className='cp-filter-label' title='Price Promotion – discount as a % of the original price of SKU'>Incentive(%)<span className='required-mark'>*</span></label>
                                            <input
                                                type='number'
                                                className='cp-input mr-16 f-s-13'
                                                disabled={!isDraft && !isActive}
                                                placeholder='Enter Incentive %'
                                                name='incentive'
                                                value={incentive}
                                                style={{ padding: '5px 8px' }}
                                                onChange={this.handleIncentiveChange}
                                            />
                                        </div>
                                        <div className='df fdi-col mb-32 width-50-pre'>
                                            <label className='cp-filter-label'>Volume Cap<span className='required-mark'>*</span> (tons)</label>
                                            <input
                                                type='number'
                                                className='cp-input mr-16 f-s-13'
                                                disabled={!isDraft && !isActive}
                                                placeholder='Enter Volume Cap'
                                                name='volumeCap'
                                                value={volumeCap}
                                                style={{ padding: '5px 8px' }}
                                                onChange={this.handleVolCapChange}
                                            />
                                        </div>
                                    </div>

                                    {/* <div className='df fdi-col mb-32 mr-16'>
                                        <label className='cp-filter-label'>Year<span className='required-mark'>*</span></label>
                                        <div className='f-s-13'>
                                            <CustomSelect.MyCustomSelect
                                                placeholder={"Year"}
                                                allowSelectAll={false}
                                                isDisabled={(isDraft) ? false : true}
                                                isMulti={false}
                                                options={years}
                                                onChange={this.handleYearChange}
                                                value={
                                                    years && selectedYear
                                                        ? years
                                                            .filter(item => {
                                                                return selectedYear === item.value;
                                                            })
                                                        : []
                                                }
                                            />
                                        </div>
                                    </div> */}

                                    <div className='df'>
                                        <div className='df fdi-col mb-32 width-50-pre mr-16'>
                                            <label className='cp-filter-label'>Week Start<span className='required-mark'>*</span></label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"Select Week Start"}
                                                    allowSelectAll={false}
                                                    isDisabled={(!startWeek?.length || (isExecuted)) ? true : false}
                                                    isMulti={false}
                                                    options={
                                                        DATA.WEEK_NO && startWeekFilterPoint
                                                            ? DATA.WEEK_NO.filter(elm => parseInt(elm.value) >= parseInt(startWeekFilterPoint))
                                                                .map(item => {
                                                                    return {
                                                                        value: item.value,
                                                                        label: item.label + ` - ${new Date().getFullYear()}`
                                                                    };
                                                                })
                                                            : []
                                                    }
                                                    onChange={this.handleStartWeekChange}
                                                    value={
                                                        DATA.WEEK_NO && selectedStartWeek
                                                            ? DATA.WEEK_NO
                                                                .filter(item => {
                                                                    return parseInt(selectedStartWeek) === parseInt(item.value);
                                                                })
                                                                .map(item => {
                                                                    return {
                                                                        value: item.value,
                                                                        label: item.label + ` - ${new Date().getFullYear()}`
                                                                    };
                                                                })
                                                            : []
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className='df fdi-col mb-32 width-50-pre mr-16'>
                                            <label className='cp-filter-label'>Week End<span className='required-mark'>*</span></label>
                                            <div className='f-s-13'>
                                                <CustomSelect.MyCustomSelect
                                                    placeholder={"Select Week End"}
                                                    allowSelectAll={false}
                                                    isDisabled={(startWeek?.length && selectedStartWeek) && (isActive || isDraft) ? false : true}
                                                    isMulti={false}
                                                    options={

                                                        parseInt(selectedYear) !== new Date().getFullYear() ?
                                                            selectedStartWeek && DATA.WEEK_NO ?
                                                                DATA.WEEK_NO
                                                                    .filter(elm => parseInt(elm.value) >= parseInt(selectedStartWeek))
                                                                    .map(item => {
                                                                        return {
                                                                            value: item.value,
                                                                            label: item.label + ` - ${selectedYear}`,
                                                                            year: selectedYear
                                                                        };
                                                                    })
                                                                : []
                                                            :

                                                            [
                                                                ...selectedStartWeek && DATA.WEEK_NO ?
                                                                    DATA.WEEK_NO
                                                                        .filter(elm => parseInt(elm.value) >= parseInt(selectedStartWeek))
                                                                        .map(item => {
                                                                            return {
                                                                                value: item.value,
                                                                                label: item.label + ` - ${new Date().getFullYear()}`,
                                                                                year: new Date().getFullYear()
                                                                            };
                                                                        })
                                                                    : []
                                                                ,
                                                                ...DATA.WEEK_NO
                                                                    .map(item => {
                                                                        return {
                                                                            value: item.value,
                                                                            label: item.label + ` - ${new Date().getFullYear() + 1}`,
                                                                            year: new Date().getFullYear() + 1
                                                                        };
                                                                    })
                                                            ]
                                                    }
                                                    onChange={this.handleEndWeekChange}
                                                    value={
                                                        selectedEndWeek ?
                                                            DATA.WEEK_NO && (yearTo === new Date().getFullYear())
                                                                ? DATA.WEEK_NO
                                                                    .filter(item => {
                                                                        return parseInt(selectedEndWeek) === parseInt(item.value);
                                                                    })
                                                                    .map(item => {
                                                                        return {
                                                                            value: item.value,
                                                                            label: item.label + ` - ${new Date().getFullYear()}`,
                                                                            year: new Date().getFullYear()
                                                                        };
                                                                    })
                                                                :
                                                                parseInt(selectedYear) === new Date().getFullYear() &&
                                                                DATA.WEEK_NO
                                                                    .filter(item => {
                                                                        return parseInt(selectedEndWeek) === parseInt(item.value);
                                                                    })
                                                                    .map(item => {
                                                                        return {
                                                                            value: item.value,
                                                                            label: item.label + ` - ${new Date().getFullYear() + 1}`,
                                                                            year: new Date().getFullYear() + 1
                                                                        };
                                                                    })
                                                            :
                                                            []
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='df fdi-col mb-32'>
                                        <label className='cp-filter-label' title='*Enter the actual material code raised for this CP'>Consumer Promotion Code</label>
                                        <input
                                            type='text'
                                            className='cp-input mr-16'
                                            placeholder='Enter Consumer Promotion Code'
                                            name='consumerPromotionCode'
                                            value={consumerPromotionCode}
                                            onChange={this.handleCPCodeChange}
                                        />
                                    </div>

                                </div>

                                <div className='df justifyContent-fe alignItem-center'>

                                    {isDraft ?
                                        <>
                                            {
                                                submitConsumerPromotionIsLoading ?
                                                    <button className='cp-btns cp-primary-btn'>Activating...</button>
                                                    :
                                                    <button className='cp-btns cp-primary-btn' onClick={() => this.handleSubmitActivity()}>Activate</button>
                                            }
                                        </>
                                        :
                                        null
                                    }
                                    {
                                        (!isDraft && isActive) ?
                                            <>
                                                {
                                                    deactivateConsumerPromotionIsLoading ?
                                                        <button className='cp-btns cp-shadow-btn mr-16'>Deactivating...</button>
                                                        :
                                                        <button className='cp-btns cp-shadow-btn mr-16' onClick={() => this.handleDeactivateActivity()}>Deactivate</button>
                                                }
                                            </>
                                            :
                                            null
                                    }

                                </div>

                            </div>
                        </div>
                }
                {
                    isOpen ?
                        <ConsumerPromotionHistory
                            isOpen={isOpen}
                            flagHandle={this.handleCPHistoryFlag}
                            selectedCategory={selectedCategory}
                            selectedBrand={selectedBrand}
                            selectedMasterSku={selectedMasterSku}
                        />
                        :
                        null
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        productCategoriesArray: state.ProductReducer.productCategories,
        productBrandsArray: state.ProductReducer.productBrands,
        productMasterSkusArray: state.ProductReducer.productMasterSkus,
        geoRegionsArray: state.GeoReducer.geoRegions,
        masterChannelArray: state.GtChannelReducer.masterChannel,
        channelArray: state.GtChannelReducer.channel,
        isGetConsumerPromotionByIdLoading: state.ConsumerPromotionReducer.isGetConsumerPromotionByIdLoading,
        consumerPromotionById: state.ConsumerPromotionReducer.consumerPromotionById,
        startWeek: state.DurationReducer.startWeek,
        consumerPromotionTypesArray: state.ConsumerPromotionReducer.consumerPromotionTypes,
        updateConsumerPromotionLoading: state.ConsumerPromotionReducer.updateConsumerPromotionLoading,
        updateConsumerPromotionData: state.ConsumerPromotionReducer.updateConsumerPromotion,
        updateConsumerPromotionHasError: state.ConsumerPromotionReducer.updateConsumerPromotionHasError,
        submitConsumerPromotionData: state.ConsumerPromotionReducer.submitConsumerPromotion,
        submitConsumerPromotionIsLoading: state.ConsumerPromotionReducer.submitConsumerPromotionIsLoading,
        submitConsumerPromotionHasError: state.ConsumerPromotionReducer.submitConsumerPromotionHasError,
        deactivateConsumerPromotionData: state.ConsumerPromotionReducer.deactivateConsumerPromotion,
        deactivateConsumerPromotionIsLoading: state.ConsumerPromotionReducer.deactivateConsumerPromotionIsLoading,
        deactivateConsumerPromotionHasError: state.ConsumerPromotionReducer.deactivateConsumerPromotionHasError
    };
};

const mapDispatchToProps = dispatch => {
    return {
        productCategories: () => {
            return dispatch(ProductMiddleware.get_categories());
        },
        productBrands: () => {
            return dispatch(ProductMiddleware.get_brands());
        },
        productMasterSkus: () => {
            return dispatch(ProductMiddleware.get_master_skus());
        },
        geoRegions: () => {
            return dispatch(GeoMiddleware.get_regions())
        },
        masterChannel: () => {
            return dispatch(ChannelMiddleware.get_masterChannel());
        },
        channel: () => {
            return dispatch(ChannelMiddleware.get_channel());
        },
        getConsumerPromotionById: (id) => {
            return dispatch(ConsumerPromotionMiddleware.getConsumerPromotionById(id));
        },
        getStartWeek: (year, week) => {
            return dispatch(DurationMiddleware.get_startWeek(year, week));
        },
        consumerPromotionTypes: () => {
            return dispatch(ConsumerPromotionMiddleware.consumerPromotionTypes());
        },
        updateConsumerPromotion: (id, data) => {
            return dispatch(ConsumerPromotionMiddleware.updateConsumerPromotion(id, data));
        },
        submitConsumerPromotion: (id, data) => {
            return dispatch(ConsumerPromotionMiddleware.submitConsumerPromotion(id, data));
        },
        deactivateConsumerPromotion: (id) => {
            return dispatch(ConsumerPromotionMiddleware.deactivateConsumerPromotion(id));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ConsumerPromotionForm);
